import { Transform } from 'class-transformer';

export function TransformInt({ toClassOnly = true } = {}) {
	return Transform(
		({ value }) => {
			if (Array.isArray(value)) {
				return value.map((val) => {
					if (val === null || val === '' || isNaN(Number(val))) {
						return null;
					}
					return parseInt(val, 10);
				});
			} else {
				if (value === null || value === '' || isNaN(Number(value))) {
					return null;
				}
				return parseInt(value, 10);
			}
		},
		{ toClassOnly },
	);
}
